import { replacerCostIfValue } from 'utils/replacerCost';

type ObjType = {
    [key: number | string]: {
        [key: number | string]: any;
    };
};

export const prepareBimOtherData = ({ checkedObjects }: { checkedObjects: ObjType }) =>
    Object.entries(checkedObjects).reduce((acc: any[], [otherId, otherValue]) => {
        if (!otherValue.parent) {
            return acc;
        }

        const otherObjectList =
            otherValue &&
            Object.entries(otherValue).reduce((objListAcc: number[], [objId, objValue]) => {
                if (objValue && objId !== 'parent' && objId !== 'value') {
                    objListAcc.push(Number(objId));
                }

                return objListAcc;
            }, []);

        const includedCost = replacerCostIfValue(otherValue.value);

        acc.push({
            contractOtherCostId: Number(otherId),
            objectIdList: otherObjectList,
            includedCost,
        });

        return acc;
    }, []);
